<template>
  <div class="modal" @click="closeModal" :class="{ active: isModal }">
    <div
      class="modal__box"
      :class="boxSize"
      :style="{ backgroundColor: bgModal }"
      @click.stop
    >
      <div
        class="modal__close"
        v-if="showCloseBtn"
        @click="$emit('closeModal')"
      >
        <!-- <i class="icon-close" /> -->
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 30C23.677 30 30.0135 23.6634 30.0135 16C30.0135 8.33656 23.6634 2 15.9865 2C8.32302 2 2 8.33656 2 16C2 23.6634 8.33656 30 16 30ZM11.383 21.9033C10.6654 21.9033 10.0967 21.3346 10.0967 20.6035C10.0967 20.2785 10.2321 19.9536 10.4894 19.7099L14.1721 16.0135L10.4894 12.3308C10.2321 12.087 10.0967 11.7621 10.0967 11.4371C10.0967 10.706 10.6654 10.1509 11.383 10.1509C11.7621 10.1509 12.06 10.2727 12.3037 10.5164L16 14.1992L19.7099 10.5029C19.9807 10.2456 20.265 10.1238 20.6306 10.1238C21.3482 10.1238 21.9168 10.6925 21.9168 11.4101C21.9168 11.7485 21.7814 12.0464 21.5242 12.3172L17.8414 16.0135L21.5242 19.6963C21.7679 19.9536 21.9033 20.265 21.9033 20.6035C21.9033 21.3346 21.3346 21.9033 20.6035 21.9033C20.2379 21.9033 19.9265 21.7679 19.6692 21.5242L16 17.8549L12.3308 21.5242C12.087 21.7814 11.7621 21.9033 11.383 21.9033Z"
            fill="#A0A0A9"
          />
        </svg>
      </div>
      <div class="modal__head" v-if="!deleteHeader">
        <div><slot name="header-left" /></div>

        <div>
          <slot name="header-center" />
          <div class="modal__title">{{ title }}</div>
        </div>

        <div>
          <slot name="header-right" />
        </div>
      </div>

      <div class="modal__body" :class="paddingBody">
        <slot />
      </div>

      <div class="modal__footer" v-if="!deleteFooter">
        <div class="modal__actions">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomModal",
  props: {
    title: String,
    width: String,
    closeOuth: Boolean,
    isModal: Boolean,
    showCloseBtn: {
      type: Boolean,
      default: true
    },
    deleteHeader: Boolean,
    deleteFooter: Boolean,
    paddingBody: {
      type: String,
      default: "sm"
    },
    bgModal: {
      default: "#ffffff"
    }
  },
  computed: {
    boxSize() {
      return this.width ? this.width : "lg";
    }
  },
  methods: {
    closeModal() {
      if (this.closeOuth) {
        this.$emit("closeModal");
      }
    }
  }
};
</script>

<style>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1060;
  padding: 1.2em;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: all 0.25s;
  flex-direction: row;
}
.modal__box {
  margin: auto;
  background-color: #fff;
  border-radius: 0.25rem;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  transition: all 0.25s;
  transform: scale(0.8);
}
.modal__box.sm {
  max-width: 300px;
}
.modal__box.md {
  max-width: 360px;
}
.modal__box.lg {
  max-width: 500px;
}
/* .modal__box.lg {
  max-width: 500px;
} */
.modal__box.xlg {
  max-width: 768px;
}
.modal__box.xxl {
  max-width: 1200px;
}
.modal__close {
  font-size: 1.4em;
  width: 40px;
  height: 40px;
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
}
.modal__head {
  padding: 1.2em 0.8em 0.5em;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal__title {
  text-align: center;
  color: #000;
  font-size: 1.2em;
  font-weight: 600;
  margin: 0;
}
@media (min-width: 375px) {
  .modal__title {
    font-size: 1.4em;
  }
}
.modal__body.sm {
  padding: 1em 1.4em;
}
.modal__body.md {
  padding: 2em;
}
.modal__body.lg {
  padding: 3em;
}
.modal__actions {
  display: flex;
}
.modal__actions button {
  width: 100%;
  background-color: transparent;
  border: 0;
  padding: 1.2em 0.5em;
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}
.modal__actions button:hover {
  background-color: rgba(222, 226, 230, 0.5);
}
.modal__actions button:focus {
  outline: none;
}
.modal__actions button:first-child {
  border-bottom-left-radius: 0.25rem;
}
.modal__actions button:last-child {
  border-bottom-right-radius: 0.25rem;
  border-right: 0;
}
.modal.active {
  visibility: visible;
  opacity: 1;
}
.modal.active .modal__box {
  transform: scale(1);
}
</style>
